function validatePhone(phone) {
    let test = phone.replace(/[^0-9]+/g, "");
    if (test.length == 11) {
        return true;
    }
    return false;
}

function validateCode(code) {
    let test = code.replace(/[^0-9]+/g, "");
    if (test.length == 6) {
        return true;
    }
    return false;
}

function validateURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?' +
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
        '((\\d{1,3}\\.){3}\\d{1,3}))' +
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=-]*)?' +
        '(\\#[-a-z\\d_]*)?$', 'i');
    return !!pattern.test(str);
}

exports.validatePhone = validatePhone;
exports.validateCode = validateCode;
exports.validateURL = validateURL;